import { mountComponents as mount } from "@root/shared/utils/mountComponents";

import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { StickyAnchorLinks } from "@root/shared/components/StickyAnchorLinks";
import { AnchorLinks } from "@root/shared/components/AnchorLinks";
import { HeadingAndContents } from "@userFrontend/features/publication/components/HeadingAndContents";
import { CategoryTopCassettes } from "@userFrontend/features/publication/components/CategoryTopCassettes";
import { DetailWorkCassettes } from "@userFrontend/features/publication/components/DetailWorkCassettes";
import { PieChart } from "@userFrontend/features/publication/components/PieChart";
import { RatioChart } from "@userFrontend/features/publication/components/RatioChart";
import { RatioWithDotChart } from "@userFrontend/features/publication/components/RatioWithDotChart";
import { SelectLinkButton } from "@userFrontend/features/publication/components/SelectLinkButton";
import { TextAreaWithWordCounter } from "@userFrontend/components/TextAreaWithWordCounter";
import { RestoreUserRewardContinuedInputsModal } from "@userFrontend/features/reward/components/RestoreUserRewardContinuedInputsModal";
import { WebToAppBanner } from "@userFrontend/components/WebToAppBanner";
import { SmartAppBanner } from "@userFrontend/components/SmartAppBanner";
import { SkillAccordionList } from "@userFrontend/features/publication/components/SkillAccordionList";
import { TelInformationFloating } from "@userFrontend/features/publication/components/TelInformationFloating";
import { ContinuedRewardInputs } from "@userFrontend/features/reward/components/ContinuedRewardInputs";
import { ClientReviewPopover } from "@userFrontend/features/reward/components/ClientReviewPopover";
import { ClientReviewInputs } from "@userFrontend//features/clientReview/components/ClientReviewInputs";
import { ClientReviewCassettes } from "@userFrontend//features/clientReview/components/ClientReviewCassettes";
import { ClientReviewDescription } from "@userFrontend//features/clientReview/components/ClientReviewDescription";
import { ClientReviewLimitReached } from "@userFrontend//features/clientReview/components/ClientReviewLimitReached";
import { WorkDetailBottomButtons } from "@userFrontend/features/publication/components/WorkDetailBottomButtons";
import { UserExperienceVoice } from "@userFrontend/features/publication/components/UserExperienceVoice";
import { TableOfContents } from "@userFrontend/features/clientReview/components/TableOfContents";
import { AttentionOnUnsolicitedEmail } from "@userFrontend/features/publication/components/AttentionOnUnsolicitedEmail";
import { NotEnterableWorkButtons } from "@userFrontend/features/publication/components/NotEnterableWorkButtons";
import { WorkWithShopWorkCassettes } from "@userFrontend//features/publication/components/WorkWithShopWorkCassettes";
import { PremiumScoutMessageBox } from "@userFrontend/features/publication/components/PremiumScoutMessageBox";
import { MoreInterviewCassettesSlider } from "@userFrontend/features/publication/components/MoreInterviewCassettesSlider";
import { WorkDetailOtherWorkCassettes } from "@userFrontend/features/publication/components/WorkDetailOtherWorkCassettes";
import { WorkDetailOtherShops } from "@userFrontend/features/publication/components/WorkDetailOtherShops";
import { ScoutCassette } from "@userFrontend/features/publication/components/ScoutCassette";
import { SearchPagination } from "@userFrontend/features/publication/components/SearchPagination";
import { MessageWebToAppBanner } from "@userFrontend/features/banner/components/MessageWebToAppBanner";
import { BannersWrapper } from "@userFrontend/features/publication/components/BannersWrapper";
import { PreferredDayAndTimes } from "@userFrontend/features/entry/components/PreferredDayAndTimes";
import { SearchForm } from "@userFrontend/features/search/components/SearchForm";
import { OtherWorksLink } from "@userFrontend/features/publication/components/OtherWorksLink";
import { ViolationReportInputs } from "@root/userFrontend/features/report/components/ViolationReportInputs";
import { RegistrationCompleteCassettes } from "@userFrontend/features/publication/components/RegistrationCompleteCassettes";
import { RegistrationCompleteSearchForm } from "@userFrontend/features/search/components/RegistrationCompleteSearchForm";
import { Assessment } from "@root/userFrontend/features/promotion/components/Assessment";
import { AssessmentResult } from "@userFrontend/features/promotion/components/AssessmentResult";
import { CassetteActionsWithDetail } from "@userFrontend/features/publication/components/CassetteActionsWithDetail";
import { ShareButtonGroup } from "@userFrontend/features/awards/components/ShareButtonGroup";

// [要リファクタ]以下、mountComponentsを１つにする為、legacyからimportしている
// pages
import { SearchSalaryHistogram } from "@legacy_user_frontend/components/pages/jobs/job_salary_histogram";
import { JobAverageGraph } from "@legacy_user_frontend/components/pages/jobs/job_average_graph";
import { JobSearchNavigation } from "@legacy_user_frontend/components/pages/jobs/job_search_navigation";
import { ClientOwnerContents } from "@legacy_user_frontend/components/pages/client/client_owner_contents";
import { ClientBrandContents } from "@legacy_user_frontend/components/pages/client/client_brand_contents";
import { PrivateLabel } from "@legacy_user_frontend/components/pages/mypage/profiles/ui_parts/private_label";
import { ProfilesShow } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show";
import { ProfilesEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_edit";
import { SchoolLogsEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/school_logs_edit";
import { CredentialsEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/credentials_edit";
import { AvailableStartDateEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/available_start_date_edit";
import { ContactableTimeRangeEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/contactable_time_range_edit";
import { SelfPrEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/self_pr_edit";
import { ProductPhotoEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/product_photo_edit";
import { UserCareerEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/user_career_edit";
import { SkillEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/skills_edit";
import { AchievementEdit } from "@legacy_user_frontend/components/pages/mypage/profiles/achievement_edit";

// projects
import { Cassettes } from "@legacy_user_frontend/components/projects/cassettes";
import { ButtonContents } from "@legacy_user_frontend/components/projects/button_contents";

// ui_parts
import { KeepButton } from "@legacy_user_frontend/components/ui_parts/buttons/keep_button";

// dev環境のみモックサーバーを立ち上げる
import { startMockServerIfDevelopment } from "@root/mocks/startMockServerIfDevelopment";
import { EnqueteReasonInputs } from "@userFrontend/features/withdrawal/components/EnqueteReasonInputs";
import { RequestGoogleReviewModal } from "@root/userFrontend/components/RequestGoogleReviewModal";
import { Step1Form } from "./features/registration/components/Step1Form";
import { ScoutStep1Form } from "./features/registration/components/ScoutStep1Form";
import { ReviewStep1Form } from "./features/registration/components/ReviewStep1Form";

startMockServerIfDevelopment();

export const mountComponents = (): void => {
  mount({
    Icon,
    HeadingAndContents,
    CategoryTopCassettes,
    DetailWorkCassettes,
    RatioChart,
    PieChart,
    SelectLinkButton,
    TextAreaWithWordCounter,
    RestoreUserRewardContinuedInputsModal,
    Cassettes,
    TableOfContents,
    AttentionOnUnsolicitedEmail,
    NotEnterableWorkButtons,
    WorkWithShopWorkCassettes,
    PremiumScoutMessageBox,
    MoreInterviewCassettesSlider,
    WorkDetailOtherWorkCassettes,
    WorkDetailOtherShops,
    ScoutCassette,
    SearchPagination,
    PreferredDayAndTimes,
    SearchSalaryHistogram,
    JobAverageGraph,
    JobSearchNavigation,
    ClientOwnerContents,
    ClientBrandContents,
    WebToAppBanner,
    SmartAppBanner,
    SkillAccordionList,
    StickyAnchorLinks,
    AnchorLinks,
    LazyLoadImage,
    ButtonContents,
    KeepButton,
    PrivateLabel,
    ProfilesShow,
    ProfilesEdit,
    SchoolLogsEdit,
    CredentialsEdit,
    AvailableStartDateEdit,
    ContactableTimeRangeEdit,
    SelfPrEdit,
    ProductPhotoEdit,
    UserCareerEdit,
    SkillEdit,
    AchievementEdit,
    RatioWithDotChart,
    TelInformationFloating,
    ContinuedRewardInputs,
    ClientReviewPopover,
    ClientReviewInputs,
    ClientReviewCassettes,
    ClientReviewDescription,
    ClientReviewLimitReached,
    WorkDetailBottomButtons,
    UserExperienceVoice,
    EnqueteReasonInputs,
    MessageWebToAppBanner,
    Step1Form,
    RequestGoogleReviewModal,
    ScoutStep1Form,
    ReviewStep1Form,
    BannersWrapper,
    SearchForm,
    OtherWorksLink,
    ViolationReportInputs,
    RegistrationCompleteCassettes,
    RegistrationCompleteSearchForm,
    GuidanceBox,
    Assessment,
    AssessmentResult,
    CassetteActionsWithDetail,
    ShareButtonGroup,
  });
};

mountComponents();
